import {AbstractControl, ValidationErrors} from '@angular/forms';

export class WhiteSpaceValidator {
    static cannotContainSpace(control: AbstractControl): ValidationErrors | null {  
            
        if (!control.value || (control.value as string).trim().length === 0 && (control.value as string).indexOf(' ') >= 0) {
            return {cannotContainSpace: true};
        }
  
        return null;
    }
}
